import React from "react";
import {useHistory} from "react-router";
import ViewProjectManager from "../../../projectManagement/manager/ViewProjectManager";
import "./index.scss";

const ViewProject = (props: any) => {
    const history = useHistory();
    const { id } = props.match.params;
    return (
        <div className="project-container container-margin-top  row">
            <ViewProjectManager idProject={id} history={history}></ViewProjectManager>
        </div>
    );
};

export default ViewProject;
